import React from 'react';
import { Typography } from '@mui/material';
import { HeaderContainer, TimeDifferenceText, ViolationNameAndSubtitleContainer } from './ViolationHeader.styles';
import { StyledAvatar } from '../../StyledAvatar/StyledAvatar';
import dayjs from 'dayjs';
import { formatMinutesToHumanReadable } from '../../../utils/helpers/timeUtils';

const ViolationHeader = ({ violation }) => {
  const { displayName, profileImageUrl, type, timestamp, details } = violation || {};
  const formattedTimeDifference = details.minutesDifference
    ? formatMinutesToHumanReadable(Math.abs(details.minutesDifference))
    : null;

  return (
    <HeaderContainer>
      <StyledAvatar size="large" src={profileImageUrl} />
      <Typography variant="bodyEmphasized">{displayName}</Typography>
      <ViolationNameAndSubtitleContainer>
        <Typography variant="bodyRegular">{type?.message}</Typography>
        {formattedTimeDifference && (
          <TimeDifferenceText variant="subheadlineRegular">{`${formattedTimeDifference} difference`}</TimeDifferenceText>
        )}
      </ViolationNameAndSubtitleContainer>
      <Typography variant="bodyRegular">{dayjs(timestamp).format('dddd, MMMM DD')}</Typography>
    </HeaderContainer>
  );
};

export default ViolationHeader;
